// extracted by mini-css-extract-plugin
export default {"container":"Products_container__+Rglr","products":"Products_products__Nt7gY","menu":"Products_menu__8te28","list":"Products_list__78by0","product":"Products_product__AJSFd"};